import React, {Component} from 'react';
import Form, {FormBody, TextInput, FormActions} from './Form';
import ReactModal from 'react-modal';
const styles = {
  modal: {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.75)',
    },
    content: {
      backgroundColor: 'white',
      position: 'fixed',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  },
};
export default class ScaleModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      min: '',
      max: ''
    }
  }

  componentWillMount() {
    let {yAxis} = this.props;
    this.setState({
      min: yAxis.min,
      max: yAxis.max
    })
  }

  handleOK = (e) => {
    e.preventDefault();
    this.props.yAxis.setExtremes(this.state.min, this.state.max, true, true);
    this.handleClose();
  };

  handleClose = () => document.getElementById('modalContainer').innerHTML = '';

  setMax = (e) => {
    this.setState({max: Math.round(e.target.value * 1000) / 1000});
    if (e.which == 13) this.handleOK(e);
  };

  setMin = (e) => {
    this.setState({min: Math.round(e.target.value * 1000) / 1000});
    if (e.which == 13) this.handleOK(e);
  };

  render() {
    return (
      <div className="scaleModal Modal">
        <div style={{background: 'white', width: '400px', boxShadow: '10px 10px 5px rgba(0,0,0,0.5)'}}>
          <div className="modalHeader">
            <div className="modalHeaderTitle">Set Scale</div>
            <a className="modalHeaderClose" onClick={this.handleClose}>
              <i className="fa fa-close" aria-hidden="true"></i>
            </a>
          </div>
          <div className="modalChildren" style={{paddingBottom:'20px', padddingTop:'0px !important'}}>
            <Form>
              <FormBody>
                <TextInput label="MAX" value={this.state.max} onChange={this.setMax} autofocus/>
                <TextInput label="MIN" value={this.state.min} onChange={this.setMin}/>
                <button onClick={this.handleOK}>OK</button><br/>
              </FormBody>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ScaleModal.js